var map = {
	"./year_2012.svg": [
		"UMsJ",
		11
	],
	"./year_2013.svg": [
		"cxuM",
		12
	],
	"./year_2014.svg": [
		"FQ5d",
		13
	],
	"./year_2015.svg": [
		"9PKv",
		14
	],
	"./year_2016.svg": [
		"3IYa",
		15
	],
	"./year_2017.svg": [
		"Dd16",
		16
	],
	"./year_2018.svg": [
		"ddfy",
		17
	],
	"./year_2019.svg": [
		"UAfn",
		18
	],
	"./year_2020.svg": [
		"kWuB",
		19
	],
	"./year_2021.svg": [
		"sY2d",
		20
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1Kl9";
module.exports = webpackAsyncContext;